import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  user: {},
  islogin: false,
  isVerify: false,
  addOfflineModels: false,
  program: 1,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.islogin = true;
    },
    setLogin: (state, action) => {
      state.isVerify = action.payload;
    },
    setProgram: (state, action) => {
      state.program = action.payload;
    },
    // shouldAddOfflineModels: (state, action) => {
    //   state.addOfflineModels = action.payload ?? !state.addOfflineModels;
    // },
    logout: (state) => initialState,
  },
});
// Action creators are generated for each case reducer function
export const {
  setUser,
  logout,
  setVerify,
  setLogin,
  shouldAddOfflineModels,
  setProgram,
} = authSlice.actions;

export default authSlice.reducer;
